import React, { useState } from 'react';
// Import Link if using React Router for internal navigation
// import { Link } from 'react-router-dom';

// Note: Header/Footer imports are commented out to prevent build errors
// if they are not in the expected ../components/ path.
// You can re-enable them if your component structure is correct.
// import Header from '../components/Header';
// import Footer from '../components/Footer';

const HospitalityUnit1 = () => {
    // State for all exercises
    const [answers, setAnswers] = useState({
        ex1q1: '', ex1q2: '', ex1q3: '',
        ex2q1: '', ex2q2: '', ex2q3: '',
        ex3q1: '', ex3q2: '', ex3q3: '',
        ex6q1: '', ex6q2: '', ex6q3: '',
        ex7q1: '',
        ex9Text: '',
        ex10Text: '',
        ex11q1: '',
        ex12q1: '', ex12q2: '', ex12q3: '', ex12q4: '',
        ex13q1: '',
        speakingPrompt: '',
        crisisPrompt: '',
    });
    const [feedback, setFeedback] = useState({});
    const [reorderList4, setReorderList4] = useState([
        { id: 'l4_1', word: 'help' }, { id: 'l4_2', word: 'Could' }, { id: 'l4_3', word: 'with' },
        { id: 'l4_4', word: 'you' }, { id: 'l4_5', word: 'me' }, { id: 'l4_6', word: '?' }
    ]);
     const [reorderList8, setReorderList8] = useState([
        { id: 'l8_1', word: 'your' }, { id: 'l8_2', word: 'key' }, { id: 'l8_3', word: 'Here' },
        { id: 'l8_4', word: 'is' }
    ]);
     const [reorderList14, setReorderList14] = useState([
        { id: 'l14_1', word: 'a' }, { id: 'l14_2', word: 'make' }, { id: 'l14_3', word: 'I' },
        { id: 'l14_4', word: 'Could' }, { id: 'l14_5', word: 'reservation' }
    ]);

    // Navigation Links Data
    const navLinks = [
       
    ];

    const handleInputChange = (id, value) => {
        setAnswers(prev => ({ ...prev, [id]: value }));
    };

    const setFeedbackFor = (id, message, isCorrect) => {
        setFeedback(prev => ({
            ...prev,
            [id]: { message, isCorrect }
        }));
    };

    // --- Check Functions ---
    const checkEx1 = () => {
        const correctAnswers = { ex1q1: 'can', ex1q2: 'must', ex1q3: 'may' };
        let correctCount = 0;
        Object.keys(correctAnswers).forEach(key => {
            if (answers[key]?.trim().toLowerCase() === correctAnswers[key]) {
                correctCount++;
            }
        });
        const isAllCorrect = correctCount === Object.keys(correctAnswers).length;
        setFeedbackFor('feedback1',
            isAllCorrect ? '🎉 Excellent! All modal verbs are correct!' : `You got ${correctCount} out of ${Object.keys(correctAnswers).length} correct. Check again.`,
            isAllCorrect
        );
    };

    const checkEx2 = () => {
        const correctAnswers = { ex2q1: 'hoteliers', ex2q2: 'service', ex2q3: 'wrong' };
        let correctCount = 0;
        Object.keys(correctAnswers).forEach(key => {
            if (answers[key] === correctAnswers[key]) {
                correctCount++;
            }
        });
        const isAllCorrect = correctCount === Object.keys(correctAnswers).length;
        setFeedbackFor('feedback2',
            isAllCorrect ? '🎉 Perfect! You remember the key facts about Ritz.' : `You got ${correctCount} out of ${Object.keys(correctAnswers).length} correct. Review the story.`,
            isAllCorrect
        );
    };

     const checkEx3 = () => {
        const correctAnswers = { ex3q1: 'manager', ex3q2: 'new_idea', ex3q3: 'expensive' };
        let correctCount = 0;
        Object.keys(correctAnswers).forEach(key => {
            if (answers[key] === correctAnswers[key]) {
                correctCount++;
            }
        });
        const isAllCorrect = correctCount === Object.keys(correctAnswers).length;
        setFeedbackFor('feedback3',
            isAllCorrect ? '🎉 Great! Vocabulary definitions matched correctly.' : `You got ${correctCount} out of ${Object.keys(correctAnswers).length} correct.`,
            isAllCorrect
        );
    };

    const checkEx6 = () => {
        const correctAnswers = { ex6q1: 'could', ex6q2: 'may', ex6q3: 'can' };
        let correctCount = 0;
        Object.keys(correctAnswers).forEach(key => {
            if (answers[key]?.trim().toLowerCase() === correctAnswers[key]) {
                correctCount++;
            }
        });
        const isAllCorrect = correctCount === Object.keys(correctAnswers).length;
        setFeedbackFor('feedback6',
             isAllCorrect ? '🎉 Correct! Your check-in dialogue uses polite modals.' : `You got ${correctCount} out of ${Object.keys(correctAnswers).length} correct. Remember: Could (polite request), May (permission), Can (ability/offer).`,
            isAllCorrect
        );
    };

     const checkEx7 = () => {
        const isCorrect = answers.ex7q1 === 'yes';
        setFeedbackFor('feedback7',
            isCorrect ? '✅ That\'s the perfect professional response!' : '❌ Remember to be polite and willing to help. Try again.',
            isCorrect
        );
    };

    const checkEx11 = () => {
        const answer = answers.ex11q1?.trim().toLowerCase();
        const isCorrect = ['can', 'could'].includes(answer);
         setFeedbackFor('feedback11',
            isCorrect ? '✅ Correct! Using "can" or "could" is a polite way to offer an upgrade.' : '❌ Think about a modal verb that offers possibility or ability.',
            isCorrect
        );
    };

     const checkEx12 = () => {
        const correctAnswers = { ex12q1: 'floor', ex12q2: 'turn', ex12q3: 'go', ex12q4: 'on' };
        let correctCount = 0;
        Object.keys(correctAnswers).forEach(key => {
            if (answers[key]?.trim().toLowerCase() === correctAnswers[key]) {
                correctCount++;
            }
        });
        const isAllCorrect = correctCount === Object.keys(correctAnswers).length;
        setFeedbackFor('feedback12',
            isAllCorrect ? '🎉 Excellent! You gave clear and concise directions.' : `You got ${correctCount} out of ${Object.keys(correctAnswers).length} correct. Check the prepositions and verbs used for directions.`,
            isAllCorrect
        );
    };

     const checkEx13 = () => {
        const isCorrect = answers.ex13q1 === 'yes';
        setFeedbackFor('feedback13',
            isCorrect ? '✅ The best answer! You showed empathy and provided a solution.' : '❌ Remember to use empathy and offer a solution. Try again.',
            isCorrect
        );
    };

    const checkSubstitution = (textId, feedbackId) => {
        const text = answers[textId] || '';
        const isCorrect = text.toLowerCase().includes('obtain');
        setFeedbackFor(feedbackId,
            isCorrect ? '✅ Correct! "Obtain" is a more formal and professional word than "get".' : '❌ Try using a more formal synonym for "get".',
            isCorrect
        );
    };

     const checkCorrection = (textId, feedbackId) => {
        const text = answers[textId] || '';
        // Basic check: looks for "must not smoke" without "to"
        const isCorrect = text.toLowerCase().includes('must not smoke') && !text.toLowerCase().includes('must not to smoke');
        setFeedbackFor(feedbackId,
             isCorrect ? '✅ Correct! Modal verbs (like must) are followed directly by the base verb, not "to".' : '❌ Check the rule for modal verbs and the infinitive marker "to".',
            isCorrect
        );
    };

    const submitSpeaking = (textId, feedbackId) => {
        const text = answers[textId] || '';
        const wordCount = text.trim().split(/\s+/).filter(word => word.length > 0).length;
        if (wordCount < 10) {
            setFeedbackFor(feedbackId, 'Please write a more detailed response (at least 10 words) to get feedback.', false);
        } else {
            // Provide more generic feedback for open-ended questions
            setFeedbackFor(feedbackId, `Excellent! Your response is empathetic and professional, showing a good understanding of the principles.`, true);
        }
    };

    // --- Reordering Logic ---
    const moveItem = (listStateSetter, index, direction) => {
        listStateSetter(prevList => {
            const newList = [...prevList];
            const item = newList[index];
            const swapIndex = index + direction;

            if (swapIndex < 0 || swapIndex >= newList.length) {
                return newList; // Cannot move outside bounds
            }

            // Swap items
            newList[index] = newList[swapIndex];
            newList[swapIndex] = item;
            return newList;
        });
    };

    const checkReorder = (listState, correctOrderWords, feedbackId) => {
        const currentOrderWords = listState.map(item => item.word);
        const isCorrect = JSON.stringify(currentOrderWords) === JSON.stringify(correctOrderWords);
        setFeedbackFor(feedbackId,
            isCorrect ? '✅ Correct! The phrase is in the right order.' : '❌ That is not the correct order. Try again!',
            isCorrect
        );
    };

    // --- Inline Styles (Derived from CSS) ---
     const styles = {
        body: { fontFamily: "'Segoe UI', sans-serif", background: '#f7f9fc', color: '#2c3e50', lineHeight: 1.6, minHeight: '100vh' },
        header: { textAlign: 'center', padding: '60px 20px 40px', background: '#1a362d', color: 'white', borderBottom: '6px solid #d4af37' },
        headerH1: { fontSize: '36px', marginBottom: '12px', textShadow: '2px 2px 4px rgba(0,0,0,0.3)' },
        tagline: { fontSize: '18px', opacity: 0.9 },
        container: { maxWidth: '900px', margin: '40px auto', padding: '30px', background: 'white', borderRadius: '12px', boxShadow: '0 6px 20px rgba(0,0,0,0.1)' },
        h2: { color: '#1a362d', marginTop: '40px', marginBottom: '20px', borderBottom: '2px solid #eee', paddingBottom: '8px' },
        storyVocabGrammar: { background: '#f0f8ff', padding: '20px', borderLeft: '4px solid #1a362d', margin: '20px 0', borderRadius: '6px' },
        input: { width: '100%', padding: '12px', margin: '10px 0', border: '1px solid #ddd', borderRadius: '6px', fontSize: '16px', background: 'white' },
        textarea: { width: '100%', padding: '12px', margin: '10px 0', border: '1px solid #ddd', borderRadius: '6px', fontSize: '16px', minHeight: '80px', fontFamily: 'inherit', background: 'white' },
        select: { width: '100%', padding: '12px', margin: '10px 0', border: '1px solid #ddd', borderRadius: '6px', fontSize: '16px', background: 'white' }, 
        exercise: { marginBottom: '30px', padding: '20px', background: '#fdfdff', borderRadius: '8px', border: '1px solid #e8e8e8' },
        exerciseHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' },
        exerciseHeaderH3: { color: '#1a362d', margin: 0 }, 
        exerciseP: { marginBottom: '15px', fontSize: '1rem' },
        labelSpan: { fontWeight: 'bold' },
        reorderList: { display: 'flex', flexDirection: 'column', gap: '10px', listStyle: 'none', padding: 0, marginTop: '15px' },
        reorderItem: { display: 'flex', alignItems: 'center', background: '#f0f8ff', padding: '10px', borderRadius: '6px', border: '1px solid #e0e0e0' },
        reorderItemSpan: { flexGrow: 1, paddingLeft: '10px' },
        reorderButtons: { display: 'flex', flexDirection: 'column', marginLeft: '10px', gap: '4px' },
        reorderButton: { background: '#eee', color: '#333', padding: '4px', borderRadius: '4px', fontSize: '12px', lineHeight: 1, border: 'none', cursor: 'pointer' },
        btn: { padding: '12px 20px', background: '#1a362d', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '16px', marginTop: '10px', transition: 'background-color 0.3s ease' },
        feedbackBase: { marginTop: '20px', padding: '15px', borderRadius: '6px', fontWeight: 'bold' },
        feedbackSuccess: { background: '#eafded', color: '#27ae60' },
        feedbackError: { background: '#fdf3f2', color: '#c0392b' },
        navLinks: { textAlign: 'center', margin: '30px 0' },
        navLink: { margin: '0 10px', color: '#1a362d', textDecoration: 'none', fontWeight: 'bold', transition: 'color 0.3s ease' },
        footer: { textAlign: 'center', padding: '20px', background: '#1a362d', color: '#d4af37', marginTop: '60px'},
        footerNavLinks: { marginBottom: '15px' },
        footerNavLink: { margin: '0 10px', color: '#d4af37', textDecoration: 'none', fontWeight: 'bold' },
        // Styles from Header Nav
        headerNavStyle: { marginTop: '20px' },
        headerNavUlStyle: { listStyle: 'none', display: 'flex', justifyContent: 'center', gap: '20px', padding: 0 },
        headerNavLinkStyle: { color: 'white', textDecoration: 'none', fontWeight: 'bold' }
    };

    // Helper to get feedback style
    const getFeedbackStyle = (id) => {
        if (!feedback[id]) return null;
        return {
            ...styles.feedbackBase,
            ...(feedback[id].isCorrect ? styles.feedbackSuccess : styles.feedbackError),
        };
    };
    
    // Add hover styles for buttons
    const handleMouseOver = (e) => e.target.style.background = '#0d271f'; // Darker green
    const handleMouseOut = (e) => e.target.style.background = '#1a362d'; // Original green
    const handleNavHoverIn = (e) => e.target.style.color = '#d4af37'; // Gold
    const handleNavHoverOut = (e) => e.target.style.color = '#1a362d'; // Dark green
    const handleFooterNavHoverIn = (e) => e.target.style.color = 'white'; // White
    const handleFooterNavHoverOut = (e) => e.target.style.color = '#d4af37'; // Gold
    const handleReorderBtnHoverIn = (e) => e.target.style.background = '#ddd';
    const handleReorderBtnHoverOut = (e) => e.target.style.background = '#eee';


    return (
        <div style={styles.body}>
            {/* <Header /> */}
            <header style={styles.header}>
                <h1 style={styles.headerH1}>Unit 1: The Legacy of César Ritz</h1>
                <p style={styles.tagline}>Leadership, Language & Reality Programming</p>
                {/* Header navigation from HTML */}
                <nav style={styles.headerNavStyle}>
                  <ul style={styles.headerNavUlStyle}>
                      {navLinks.map(link => (
                          <li key={link.label}>
                              <a href={link.href} style={styles.headerNavLinkStyle}
                                 onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                                 onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>
                                  {link.label}
                              </a>
                          </li>
                      ))}
                  </ul>
                </nav>
            </header>

            <div style={styles.container}>
                <h2 style={styles.h2}>📖 Story: The Hotelier of Kings</h2>
                <div style={styles.storyVocabGrammar}>
                    <p>César Ritz, born in 1850 in Switzerland, became known as "the hotelier of kings and the king of hoteliers." He managed some of the world's most luxurious hotels, including The Savoy in London and The Ritz in Paris.</p>
                    <p>Ritz believed that a great hotel was not just about comfort, but about service. He famously said, "The customer is never wrong," and practiced a form of "reality programming" by shaping the guest's perception of perfection.</p>
                    <p>He was famous for his memory — he could remember every guest's name and preferences. He also understood the power of publicity. If a hotel wanted to be known, it had to become a subject of conversation.</p>
                    <p>Ritz introduced many innovations: soft beds, private bathrooms, and even a special room for guests who wanted to write letters. His standards were so high that they became the model for modern luxury hotels.</p>
                    <p>When asked what made a great hotelier, Ritz said: "Never say no when a client asks for something, even if it is the moon. You can always try, and anyhow there is plenty of time afterwards to explain that it was not possible."</p>
                </div>

                <h2 style={styles.h2}>📚 Vocabulary & Grammar</h2>
                <div style={styles.storyVocabGrammar}>
                    <h4>Vocabulary Words</h4>
                    <p><strong>hotelier</strong>: a person who runs a hotel</p>
                    <p><strong>luxury</strong>: high quality, expensive, comfortable</p>
                    <p><strong>innovation</strong>: a new idea or method</p>
                    <p><strong>standard</strong>: a level of quality</p>
                    <p><strong>publicity</strong>: attention from the media</p>
                </div>
                 <div style={styles.storyVocabGrammar}>
                    <h4>Grammar: Modal Verbs in Service</h4>
                    <p>Modal verbs (can, could, may, must, should) are not just about grammar; they are tools for professional hospitality. They allow you to be polite, clear, and reassuring. Mastering them is a key skill for a successful hotelier.</p>
                </div>

                <h2 style={styles.h2}>📝 Interactive Exercises</h2>

                {/* Exercise 1 */}
                <div style={styles.exercise}>
                    <div style={styles.exerciseHeader}>
                        <h3 style={styles.exerciseHeaderH3}>Exercise 1 of 15: Modal Verbs</h3>
                        <span>(Grammar)</span>
                    </div>
                    <p style={styles.exerciseP}>Complete the sentences with the correct modal verb: <strong>can, could, may, must, should</strong>.</p>
                    <ol className="list-decimal pl-5 space-y-2"> {/* Added class for list styling */}
                        <li><label style={styles.labelSpan}>The hotel manager <input type="text" id="ex1q1" style={styles.input} value={answers.ex1q1} onChange={(e) => handleInputChange('ex1q1', e.target.value)} /> speak three languages fluently.</label></li>
                        <li><label style={styles.labelSpan}>All staff <input type="text" id="ex1q2" style={styles.input} value={answers.ex1q2} onChange={(e) => handleInputChange('ex1q2', e.target.value)} /> attend the morning briefing.</label></li>
                        <li><label style={styles.labelSpan}><input type="text" id="ex1q3" style={styles.input} value={answers.ex1q3} onChange={(e) => handleInputChange('ex1q3', e.target.value)} /> I see your passport, please?</label></li>
                    </ol>
                    <button style={styles.btn} onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut} onClick={checkEx1}>Check Answers</button>
                    {feedback.feedback1 && <div style={getFeedbackStyle('feedback1')}>{feedback.feedback1.message}</div>}
                </div>

                 {/* Exercise 2 */}
                <div style={styles.exercise}>
                    <div style={styles.exerciseHeader}>
                        <h3 style={styles.exerciseHeaderH3}>Exercise 2 of 15: Fact-Finding</h3>
                        <span>(Comprehension)</span>
                    </div>
                    <p style={styles.exerciseP}>Select the correct option based on the story about César Ritz.</p>
                    <ol className="list-decimal pl-5 space-y-2">
                        <li>
                            <label style={styles.labelSpan}>Ritz was known as the "king of..."</label>
                            <select id="ex2q1" style={styles.select} value={answers.ex2q1} onChange={(e) => handleInputChange('ex2q1', e.target.value)}>
                                <option value="">--Select--</option>
                                <option value="hoteliers">hoteliers</option>
                                <option value="chefs">chefs</option>
                                <option value="butlers">butlers</option>
                            </select>
                        </li>
                        <li>
                            <label style={styles.labelSpan}>He believed a great hotel was about...</label>
                            <select id="ex2q2" style={styles.select} value={answers.ex2q2} onChange={(e) => handleInputChange('ex2q2', e.target.value)}>
                                <option value="">--Select--</option>
                                <option value="price">price</option>
                                <option value="comfort">comfort</option>
                                <option value="service">service</option>
                            </select>
                        </li>
                        <li>
                             <label style={styles.labelSpan}>His famous quote was "The customer is never..."</label>
                            <select id="ex2q3" style={styles.select} value={answers.ex2q3} onChange={(e) => handleInputChange('ex2g3', e.target.value)}>
                                <option value="">--Select--</option>
                                <option value="right">right</option>
                                <option value="wrong">wrong</option>
                                <option value="satisfied">satisfied</option>
                            </select>
                        </li>
                    </ol>
                    <button style={styles.btn} onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut} onClick={checkEx2}>Check Answers</button>
                    {feedback.feedback2 && <div style={getFeedbackStyle('feedback2')}>{feedback.feedback2.message}</div>}
                </div>

                {/* Exercise 3 */}
                <div style={styles.exercise}>
                    <div style={styles.exerciseHeader}>
                        <h3 style={styles.exerciseHeaderH3}>Exercise 3 of 15: Vocabulary Match</h3>
                        <span>(Vocabulary)</span>
                    </div>
                    <p style={styles.exerciseP}>Match the word to its correct definition.</p>
                     <ol className="list-decimal pl-5 space-y-2">
                        <li>
                            <label style={styles.labelSpan}><strong>Hotelier:</strong></label>
                            <select id="ex3q1" style={styles.select} value={answers.ex3q1} onChange={(e) => handleInputChange('ex3q1', e.target.value)}>
                                <option value="">--Select--</option><option value="new_idea">a new idea</option><option value="manager">a hotel manager</option><option value="expensive">high quality, expensive</option>
                            </select>
                        </li>
                         <li>
                            <label style={styles.labelSpan}><strong>Innovation:</strong></label>
                            <select id="ex3q2" style={styles.select} value={answers.ex3q2} onChange={(e) => handleInputChange('ex3q2', e.target.value)}>
                                <option value="">--Select--</option><option value="new_idea">a new idea</option><option value="manager">a hotel manager</option><option value="level">a level of quality</option>
                            </select>
                        </li>
                         <li>
                            <label style={styles.labelSpan}><strong>Luxury:</strong></label>
                            <select id="ex3q3" style={styles.select} value={answers.ex3q3} onChange={(e) => handleInputChange('ex3q3', e.target.value)}>
                                <option value="">--Select--</option><option value="manager">a hotel manager</option><option value="expensive">high quality, expensive</option><option value="level">a level of quality</option>
                            </select>
                        </li>
                    </ol>
                    <button style={styles.btn} onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut} onClick={checkEx3}>Check Answers</button>
                    {feedback.feedback3 && <div style={getFeedbackStyle('feedback3')}>{feedback.feedback3.message}</div>}
                </div>

                {/* Exercise 4 */}
                <div style={styles.exercise}>
                    <div style={styles.exerciseHeader}>
                        <h3 style={styles.exerciseHeaderH3}>Exercise 4 of 15: Reorder the Phrase</h3>
                        <span>(Syntax & Politeness)</span>
                    </div>
                    <p style={styles.exerciseP}>Arrange the words to form a correct and polite question for a guest.</p>
                    <ul style={styles.reorderList}>
                        {reorderList4.map((item, index) => (
                            <li key={item.id} style={styles.reorderItem}>
                                <span style={styles.reorderItemSpan}>{item.word}</span>
                                <div style={styles.reorderButtons}>
                                    <button style={styles.reorderButton} onMouseEnter={handleReorderBtnHoverIn} onMouseLeave={handleReorderBtnHoverOut} onClick={() => moveItem(setReorderList4, index, -1)} disabled={index === 0}>▲</button>
                                    <button style={styles.reorderButton} onMouseEnter={handleReorderBtnHoverIn} onMouseLeave={handleReorderBtnHoverOut} onClick={() => moveItem(setReorderList4, index, 1)} disabled={index === reorderList4.length - 1}>▼</button>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <button style={styles.btn} onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut} onClick={() => checkReorder(reorderList4, ['Could', 'you', 'help', 'me', 'with', '?'], 'feedback4')}>Check Order</button>
                    {feedback.feedback4 && <div style={getFeedbackStyle('feedback4')}>{feedback.feedback4.message}</div>}
                </div>

                {/* Exercise 5 */}
                <div style={styles.exercise}>
                    <div style={styles.exerciseHeader}>
                         <h3 style={styles.exerciseHeaderH3}>Exercise 5 of 15: "The Customer is Never Wrong"</h3>
                         <span>(Service & Empathy)</span>
                    </div>
                    <p style={styles.exerciseP}>A guest says, "I am not happy with my room because it does not have a view of the park." Using Ritz's philosophy, write a response that addresses the concern without saying "no."</p>
                    <textarea
                        id="speakingPrompt"
                        style={styles.textarea}
                        rows="6"
                        placeholder="Start your response here..."
                        value={answers.speakingPrompt}
                        onChange={(e) => handleInputChange('speakingPrompt', e.target.value)}
                    />
                    <button style={styles.btn} onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut} onClick={() => submitSpeaking('speakingPrompt', 'feedback5')}>Submit Response</button>
                    {feedback.feedback5 && <div style={getFeedbackStyle('feedback5')}>{feedback.feedback5.message}</div>}
                </div>

                 {/* Exercise 6 */}
                <div style={styles.exercise}>
                    <div style={styles.exerciseHeader}>
                        <h3 style={styles.exerciseHeaderH3}>Exercise 6 of 15: Check-in Dialogue</h3>
                        <span>(Procedure & Politeness)</span>
                    </div>
                    <p style={styles.exerciseP}>Complete the polite check-in dialogue using the correct verbs (could, may, can).</p>
                    <ol className="list-decimal pl-5 space-y-2">
                        <li><label style={styles.labelSpan}>Good evening. <input type="text" id="ex6q1" style={styles.input} value={answers.ex6q1} onChange={(e) => handleInputChange('ex6q1', e.target.value)} /> you please confirm your name for me?</label></li>
                        <li><label style={styles.labelSpan}>Of course. Here is my ID. <input type="text" id="ex6q2" style={styles.input} value={answers.ex6q2} onChange={(e) => handleInputChange('ex6q2', e.target.value)} /> I also get my room key?</label></li>
                        <li><label style={styles.labelSpan}>Certainly. Your room number is 405. <input type="text" id="ex6q3" style={styles.input} value={answers.ex6q3} onChange={(e) => handleInputChange('ex6q3', e.target.value)} /> I help you with your luggage?</label></li>
                    </ol>
                    <button style={styles.btn} onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut} onClick={checkEx6}>Check Answers</button>
                    {feedback.feedback6 && <div style={getFeedbackStyle('feedback6')}>{feedback.feedback6.message}</div>}
                </div>

                {/* Exercise 7 */}
                <div style={styles.exercise}>
                    <div style={styles.exerciseHeader}>
                        <h3 style={styles.exerciseHeaderH3}>Exercise 7 of 15: Guest Requests</h3>
                        <span>(Politeness & Problem-Solving)</span>
                    </div>
                    <p style={styles.exerciseP}>A guest says: "I need more towels." Which response is the most professional and polite?</p>
                    <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                       <div><input type="radio" id="ex7q1_no" name="ex7q1" value="no" checked={answers.ex7q1 === 'no'} onChange={(e) => handleInputChange('ex7q1', e.target.value)} /><label htmlFor="ex7q1_no" style={{marginLeft: '8px'}}> No, we already gave you enough.</label></div>
                       <div><input type="radio" id="ex7q1_maybe" name="ex7q1" value="maybe" checked={answers.ex7q1 === 'maybe'} onChange={(e) => handleInputChange('ex7q1', e.target.value)} /><label htmlFor="ex7q1_maybe" style={{marginLeft: '8px'}}> Maybe later, I'm busy.</label></div>
                       <div><input type="radio" id="ex7q1_yes" name="ex7q1" value="yes" checked={answers.ex7q1 === 'yes'} onChange={(e) => handleInputChange('ex7q1', e.target.value)} /><label htmlFor="ex7q1_yes" style={{marginLeft: '8px'}}> Certainly, I will have those sent to your room right away.</label></div>
                    </div>
                    <button style={styles.btn} onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut} onClick={checkEx7}>Check Answer</button>
                    {feedback.feedback7 && <div style={getFeedbackStyle('feedback7')}>{feedback.feedback7.message}</div>}
                </div>

                {/* Exercise 8 */}
                 <div style={styles.exercise}>
                    <div style={styles.exerciseHeader}>
                        <h3 style={styles.exerciseHeaderH3}>Exercise 8 of 15: Reorder a Check-in Sentence</h3>
                        <span>(Syntax & Procedure)</span>
                    </div>
                    <p style={styles.exerciseP}>Arrange the words to form a correct sentence for a guest.</p>
                     <ul style={styles.reorderList}>
                        {reorderList8.map((item, index) => (
                            <li key={item.id} style={styles.reorderItem}>
                                <span style={styles.reorderItemSpan}>{item.word}</span>
                                <div style={styles.reorderButtons}>
                                    <button style={styles.reorderButton} onMouseEnter={handleReorderBtnHoverIn} onMouseLeave={handleReorderBtnHoverOut} onClick={() => moveItem(setReorderList8, index, -1)} disabled={index === 0}>▲</button>
                                    <button style={styles.reorderButton} onMouseEnter={handleReorderBtnHoverIn} onMouseLeave={handleReorderBtnHoverOut} onClick={() => moveItem(setReorderList8, index, 1)} disabled={index === reorderList8.length - 1}>▼</button>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <button style={styles.btn} onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut} onClick={() => checkReorder(reorderList8, ['Here', 'is', 'your', 'key'], 'feedback8')}>Check Order</button>
                    {feedback.feedback8 && <div style={getFeedbackStyle('feedback8')}>{feedback.feedback8.message}</div>}
                </div>

                 {/* Exercise 9 */}
                 <div style={styles.exercise}>
                    <div style={styles.exerciseHeader}>
                        <h3 style={styles.exerciseHeaderH3}>Exercise 9 of 15: Professional Substitution</h3>
                        <span>(Formal Language)</span>
                    </div>
                    <p style={styles.exerciseP}>Rewrite the sentence using a more formal word for "get."</p>
                    <p>Sentence: "Can I get your passport?"</p>
                    <textarea
                        id="ex9Text"
                        style={styles.textarea} rows="2"
                        placeholder="Start your rewrite here..."
                        value={answers.ex9Text}
                        onChange={(e) => handleInputChange('ex9Text', e.target.value)}
                    />
                    <button style={styles.btn} onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut} onClick={() => checkSubstitution('ex9Text', 'feedback9')}>Check Rewrite</button>
                    {feedback.feedback9 && <div style={getFeedbackStyle('feedback9')}>{feedback.feedback9.message}</div>}
                </div>

                 {/* Exercise 10 */}
                 <div style={styles.exercise}>
                    <div style={styles.exerciseHeader}>
                         <h3 style={styles.exerciseHeaderH3}>Exercise 10 of 15: Correct the Error</h3>
                         <span>(Grammar)</span>
                    </div>
                    <p style={styles.exerciseP}>Correct the mistake in the sentence: "He must not to smoke here."</p>
                    <textarea
                        id="ex10Text"
                        style={styles.textarea} rows="2"
                        placeholder="Rewrite the sentence..."
                        value={answers.ex10Text}
                        onChange={(e) => handleInputChange('ex10Text', e.target.value)}
                    />
                    <button style={styles.btn} onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut} onClick={() => checkCorrection('ex10Text', 'feedback10')}>Check Correction</button>
                    {feedback.feedback10 && <div style={getFeedbackStyle('feedback10')}>{feedback.feedback10.message}</div>}
                </div>

                {/* Exercise 11 */}
                <div style={styles.exercise}>
                    <div style={styles.exerciseHeader}>
                        <h3 style={styles.exerciseHeaderH3}>Exercise 11 of 15: Upselling</h3>
                        <span>(Sales & Modals)</span>
                    </div>
                     <p style={styles.exerciseP}>A guest is checking in. Use a modal verb (can/could) to politely offer an upgrade. </p>
                    <label style={styles.labelSpan}>"For an additional fee, you <input type="text" id="ex11q1" style={{...styles.input, width: '100px', display: 'inline-block', marginLeft: '5px', marginRight: '5px'}} value={answers.ex11q1} onChange={(e) => handleInputChange('ex11q1', e.target.value)} /> upgrade to a suite."</label>
                    <button style={styles.btn} onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut} onClick={checkEx11}>Check Answer</button>
                    {feedback.feedback11 && <div style={getFeedbackStyle('feedback11')}>{feedback.feedback11.message}</div>}
                </div>

                {/* Exercise 12 */}
                <div style={styles.exercise}>
                    <div style={styles.exerciseHeader}>
                        <h3 style={styles.exerciseHeaderH3}>Exercise 12 of 15: Giving Directions</h3>
                        <span>(Clarity & Location)</span>
                    </div>
                    <p style={styles.exerciseP}>Complete the directions to the pool. Use the words: <strong>floor, turn, go, on</strong>.</p>
                    <p style={{ ...styles.exerciseP, lineHeight: '2.5' }}> {/* Increased line height */}
                        "The pool is located on the rooftop <input type="text" id="ex12q1" style={{...styles.input, width:'80px', display:'inline-block', margin: '0 5px', padding: '5px'}} value={answers.ex12q1} onChange={(e) => handleInputChange('ex12q1', e.target.value)} />.
                        Take the elevator to the fifth floor, then <input type="text" id="ex12q2" style={{...styles.input, width:'80px', display:'inline-block', margin: '0 5px', padding: '5px'}} value={answers.ex12q2} onChange={(e) => handleInputChange('ex12q2', e.target.value)} /> left.
                        <input type="text" id="ex12q3" style={{...styles.input, width:'80px', display:'inline-block', margin: '0 5px', padding: '5px'}} value={answers.ex12q3} onChange={(e) => handleInputChange('ex12q3', e.target.value)} /> past the gym, and you will see it
                        <input type="text" id="ex12q4" style={{...styles.input, width:'80px', display:'inline-block', margin: '0 5px', padding: '5px'}} value={answers.ex12q4} onChange={(e) => handleInputChange('ex12q4', e.target.value)} /> your left."
                    </p>
                    <button style={styles.btn} onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut} onClick={checkEx12}>Check Answers</button>
                    {feedback.feedback12 && <div style={getFeedbackStyle('feedback12')}>{feedback.feedback12.message}</div>}
                </div>

                {/* Exercise 13 */}
                 <div style={styles.exercise}>
                    <div style={styles.exerciseHeader}>
                        <h3 style={styles.exerciseHeaderH3}>Exercise 13 of 15: Complaint Handling</h3>
                        <span>(Problem-Solving & Empathy)</span>
                    </div>
                    <p style={styles.exerciseP}>A guest says, "My room is too noisy." How would you respond professionally?</p>
                    <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                       <div><input type="radio" id="ex13q1_no" name="ex13q1" value="no" checked={answers.ex13q1 === 'no'} onChange={(e) => handleInputChange('ex13q1', e.target.value)} /><label htmlFor="ex13q1_no" style={{marginLeft: '8px'}}> You must not complain about the noise.</label></div>
                       <div><input type="radio" id="ex13q1_yes" name="ex13q1" value="yes" checked={answers.ex13q1 === 'yes'} onChange={(e) => handleInputChange('ex13q1', e.target.value)} /><label htmlFor="ex13q1_yes" style={{marginLeft: '8px'}}> I am so sorry about that. I can move you to a quieter room.</label></div>
                       <div><input type="radio" id="ex13q1_maybe" name="ex13q1" value="maybe" checked={answers.ex13q1 === 'maybe'} onChange={(e) => handleInputChange('ex13q1', e.target.value)} /><label htmlFor="ex13q1_maybe" style={{marginLeft: '8px'}}> Maybe you can just use earplugs.</label></div>
                    </div>
                    <button style={styles.btn} onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut} onClick={checkEx13}>Check Answer</button>
                    {feedback.feedback13 && <div style={getFeedbackStyle('feedback13')}>{feedback.feedback13.message}</div>}
                </div>

                 {/* Exercise 14 */}
                 <div style={styles.exercise}>
                    <div style={styles.exerciseHeader}>
                        <h3 style={styles.exerciseHeaderH3}>Exercise 14 of 15: Reorder for Reservations</h3>
                        <span>(Procedure & Politeness)</span>
                    </div>
                    <p style={styles.exerciseP}>Arrange the words to form a polite question about making a reservation.</p>
                     <ul style={styles.reorderList}>
                        {reorderList14.map((item, index) => (
                            <li key={item.id} style={styles.reorderItem}>
                                <span style={styles.reorderItemSpan}>{item.word}</span>
                                <div style={styles.reorderButtons}>
                                    <button style={styles.reorderButton} onMouseEnter={handleReorderBtnHoverIn} onMouseLeave={handleReorderBtnHoverOut} onClick={() => moveItem(setReorderList14, index, -1)} disabled={index === 0}>▲</button>
                                    <button style={styles.reorderButton} onMouseEnter={handleReorderBtnHoverIn} onMouseLeave={handleReorderBtnHoverOut} onClick={() => moveItem(setReorderList14, index, 1)} disabled={index === reorderList14.length - 1}>▼</button>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <button style={styles.btn} onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut} onClick={() => checkReorder(reorderList14, ['Could', 'I', 'make', 'a', 'reservation'], 'feedback14')}>Check Order</button>
                    {feedback.feedback14 && <div style={getFeedbackStyle('feedback14')}>{feedback.feedback14.message}</div>}
                </div>

                {/* Exercise 15 */}
                <div style={styles.exercise}>
                    <div style={styles.exerciseHeader}>
                         <h3 style={styles.exerciseHeaderH3}>Exercise 15 of 15: Leadership Language</h3>
                         <span>(Crisis & Clarity)</span>
                    </div>
                    <p style={styles.exerciseP}>Imagine there is a minor fire alarm. Write a short, clear message you would broadcast to guests to ensure their safety and calmness. Use modal verbs (e.g., must, should, may) to express necessity and possibility.</p>
                    <textarea
                        id="crisisPrompt"
                        style={styles.textarea}
                        rows="6"
                        placeholder="Example: 'Attention guests, a fire alarm has been activated. You must evacuate via the nearest stairwell...'"
                        value={answers.crisisPrompt}
                        onChange={(e) => handleInputChange('crisisPrompt', e.target.value)}
                    />
                    <button style={styles.btn} onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut} onClick={() => submitSpeaking('crisisPrompt', 'feedback15')}>Submit Response</button>
                    {feedback.feedback15 && <div style={getFeedbackStyle('feedback15')}>{feedback.feedback15.message}</div>}
                </div>

                 {/* Navigation Links at Bottom */}
               

            </div>

             {/* Footer - Consistent */}
             <footer style={styles.footer}>
                 <nav style={styles.footerNavLinks}>
                   {navLinks.map(link => (
                          <a key={link.label} href={link.href} style={styles.footerNavLink}
                             onMouseEnter={handleFooterNavHoverIn}
                             onMouseLeave={handleFooterNavHoverOut}>
                              {link.label}
                          </a>
                      ))}
                </nav>
                 <p>© 2025 Aulice Academy. Reality is programmable. Smart people are its architects.</p>
            </footer>
        {/* <Footer /> */}
        </div>
    );
};

export default HospitalityUnit1;

